import { render, staticRenderFns } from "./AppStacksPanel.vue?vue&type=template&id=ca123d06&scoped=true"
import script from "./AppStacksPanel.vue?vue&type=script&lang=ts"
export * from "./AppStacksPanel.vue?vue&type=script&lang=ts"
import style0 from "./AppStacksPanel.vue?vue&type=style&index=0&id=ca123d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca123d06",
  null
  
)

export default component.exports